"use client"

import Link from "next/link"

export default function Footer() {
  return (
    <footer className="border-t">
      <div className="container py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="font-semibold mb-3">Summit Growth</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              AI Infrastructures for Sales Teams
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
             Summit Lead Generation Ltd
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Company No: 10721981
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-3">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/ai-for-solar-sales" className="text-sm text-gray-600 dark:text-gray-300 hover:text-blue-600">
                  AI For Solar Sales
                </Link>
              </li>
              <li>
                <Link href="/ai-in-cybersecurity-sales" className="text-sm text-gray-600 dark:text-gray-300 hover:text-blue-600">
                  AI For Cybersecurity Sales
                </Link>
              </li>
              <li>
                <Link href="/ai-for-marketing-agencies" className="text-sm text-gray-600 dark:text-gray-300 hover:text-blue-600">
                  AI For Marketing Agencies
                </Link>
              </li>
              <li>
                <Link href="/ai-in-saas" className="text-sm text-gray-600 dark:text-gray-300 hover:text-blue-600">
                  AI For SaaS Sales
                </Link>
              </li>
              <li>
                <Link href="/ai-for-tech-sales" className="text-sm text-gray-600 dark:text-gray-300 hover:text-blue-600">
                  AI For Tech Sales
                </Link>
              </li>
              <li>
                <Link href="/ai-for-msp" className="text-sm text-gray-600 dark:text-gray-300 hover:text-blue-600">
                 AI For IT Sales
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-3">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/terms" className="text-sm text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link href="/privacy" className="text-sm text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <a 
                  href="https://ico.org.uk/ESDWebPages/Entry/ZB449302"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400"
                >
                  ICO Registration: ZB449302
                </a>
              </li>
              <li>
                
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-3">Contact</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="mailto:hello@gosummitgrowth.com"
                  className="text-sm text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400"
                >
                  hello@gosummitgrowth.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              © {new Date().getFullYear()} Summit Lead Generation Ltd. All rights reserved.
            </p>
           
          </div>
        </div>
      </div>
    </footer>
  )
}
